import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=5ad9eada&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=5ad9eada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad9eada",
  null
  
)

export default component.exports